import { appSchema, tableSchema } from "@nozbe/watermelondb";

export const baseColumns: any = [
  { name: "created_at", type: "number" },
  { name: "updated_at", type: "number" },
  { name: "deleted_at", type: "number", isOptional: true },
];

export const syncMetaColumns: any = [
  { name: "sync_state", type: "string", isOptional: false },
  { name: "num_sync_attempts", type: "number", isOptional: false },
  { name: "last_sync_attempt", type: "number", isOptional: true },
];

export default appSchema({
  version: 22,
  tables: [
    tableSchema({
      name: "fetch_meta",
      columns: [
        { name: "last_fetch", type: "number", isOptional: true },
        { name: "initial_sync_occoured", type: "boolean" },
      ],
    }),
    tableSchema({
      name: "invoice_sequence",
      columns: [
        { name: "terminal_id", type: "string", isOptional: false },
        { name: "sequence", type: "number", isOptional: false },
      ],
    }),
    tableSchema({
      name: "sales",
      columns: [
        { name: "external_id", type: "string", isOptional: true },
        { name: "note", type: "string", isOptional: true },
        { name: "terminal_id", type: "string", isOptional: false },
        { name: "is_refund", type: "boolean" },
        { name: "staff_id", type: "string", isOptional: false },
        { name: "location_id", type: "string", isOptional: false },
        { name: "receipt_to", type: "string", isOptional: true },
        { name: "customer_id", type: "string", isOptional: false },
        { name: "invoice_number", type: "string", isOptional: true },
        { name: "invoice_sequence", type: "number", isOptional: true },
        { name: "payments", type: "string", isOptional: false },
        { name: "deposit_percent", type: "number", isOptional: true },
        { name: "sale_completed_at", type: "number", isOptional: true },
        { name: "sale_state", type: "string" },
        { name: "metadata", type: "string", isOptional: true },
        { name: "purchase_order_number", type: "string", isOptional: true },
        {
          name: "quote_accepted",
          type: "boolean",
          isOptional: true,
        },
        {
          name: "gift_voucher_code",
          type: "string",
          isOptional: true,
        },
        {
          name: "expected_pickup_date",
          type: "number",
          isOptional: true,
        },
        ...syncMetaColumns,
      ],
    }),
    tableSchema({
      name: "sale_items",
      columns: [
        { name: "external_id", type: "string", isOptional: true },
        { name: "sale_id", type: "string", isOptional: false },
        { name: "product_id", type: "string", isOptional: false },
        { name: "product_kit_id", type: "string", isOptional: true },
        { name: "is_kit", type: "boolean", isOptional: true },
        { name: "stock_code", type: "string", isOptional: true },
        {
          name: "stock_number",
          type: "string",
          isOptional: true,
          isIndexed: true,
        },
        { name: "serial_number", type: "string", isOptional: true },
        { name: "quantity", type: "number", isOptional: false },
        { name: "base_price", type: "number", isOptional: false },
        { name: "cost", type: "number", isOptional: false },
        { name: "tax", type: "number", isOptional: false },
        { name: "adjustments", type: "string", isOptional: false },
        { name: "loyalty_point_earn_rate", type: "number", isOptional: false },
        { name: "metadata", type: "string", isOptional: false },
        { name: "tax_rate_percent", type: "number", isOptional: true },
        { name: "name", type: "string", isOptional: true },
        { name: "customer_note", type: "string", isOptional: true },
        { name: "gift_card_number", type: "string", isOptional: true },
      ],
    }),
    tableSchema({
      name: "products",
      columns: [
        { name: "name", type: "string" },
        { name: "active", type: "boolean" },
        { name: "internal", type: "boolean", isOptional: false },
        { name: "taxable", type: "boolean" },
        { name: "description", type: "string", isOptional: true },
        { name: "web_description", type: "string", isOptional: true },
        { name: "price_lookup", type: "string", isOptional: true },
        { name: "weight", type: "number", isOptional: true },
        { name: "uom", type: "string", isOptional: true },
        { name: "web_price", type: "number", isOptional: true },
        { name: "stock_code", type: "string", isOptional: true },
        { name: "stock_number", type: "string", isIndexed: true },
        { name: "variant_parent_id", type: "string", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "supplier_stock_code", type: "string", isOptional: true },
        {
          name: "location_inventory_pricing",
          type: "string",
          isOptional: false,
        },

        { name: "total_inventory", type: "number", isOptional: false },
        { name: "has_variants", type: "boolean", isOptional: false },
        { name: "display_name", type: "string", isOptional: false },
        { name: "total_variants", type: "number", isOptional: false },
        { name: "options", type: "string", isOptional: false },
        { name: "selected_options", type: "string", isOptional: false },
        { name: "discountable", type: "boolean", isOptional: false },
        { name: "serial_numbers_arr", type: "boolean", isOptional: false },
        { name: "serial_numbers_sale", type: "boolean", isOptional: false },
        { name: "department_id", type: "string", isOptional: true },
        { name: "category_id", type: "string", isOptional: true },
        { name: "supplier_id", type: "string", isOptional: true },
        { name: "product_kit_id", type: "string", isOptional: true },
        { name: "tags", type: "string", isOptional: true },

        {
          name: "loyalty_point_redeem_value",
          type: "number",
          isOptional: false,
        },
        { name: "loyalty_point_earn_value", type: "number", isOptional: false },
        { name: "adjustable", type: "boolean", isOptional: false },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "customers",
      columns: [
        { name: "first_name", type: "string", isOptional: false },
        { name: "last_name", type: "string", isOptional: false },
        { name: "mobile_number", type: "string", isOptional: true },
        { name: "phone_number", type: "string", isOptional: true },
        { name: "email_address", type: "string", isOptional: true },
        { name: "gender", type: "string", isOptional: true },
        { name: "contact_preference", type: "string", isOptional: true },
        { name: "loyalty_points", type: "number", isOptional: false },
        { name: "is_retailer_cus_account", type: "boolean", isOptional: false },
        { name: "is_trade_customer", type: "boolean", isOptional: false },
        { name: "retailer_id", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "categories",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "description", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "departments",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "description", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "serial_numbers",
      columns: [
        {
          name: "productLocationInventoryPricingId",
          type: "string",
          isOptional: false,
        },
        { name: "value", type: "string", isOptional: false },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "layouts",
      columns: [
        { name: "terminal_id", type: "string", isOptional: false },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "layout_nodes",
      columns: [
        { name: "label", type: "string", isOptional: true },
        { name: "color", type: "string", isOptional: true },
        { name: "product_id", type: "string", isOptional: true },
        { name: "layout_id", type: "string", isOptional: false },
        { name: "show_image", type: "boolean", isOptional: false },
        { name: "type", type: "string", isOptional: true },
        { name: "position", type: "number" },
        { name: "action", type: "string", isOptional: true },
        { name: "link", type: "string", isOptional: true },
        { name: "filter", type: "string", isOptional: true },
        { name: "image_url", type: "string", isOptional: true },
        { name: "label_color", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "inventory_movements",
      columns: [
        { name: "name", type: "string", isOptional: true },
        { name: "status", type: "string" },
        { name: "inventory_movement_date", type: "number", isOptional: true },
        { name: "received_at", type: "string", isOptional: true },
        { name: "dispatched_at", type: "string", isOptional: true },
        { name: "reference_no", type: "string", isOptional: true },
        { name: "sent_at", type: "string", isOptional: true },
        { name: "cancelled_at", type: "string", isOptional: true },
        { name: "due_at", type: "string", isOptional: true },
        { name: "completed_at", type: "number", isOptional: true },
        { name: "filters", type: "string", isOptional: true },
        { name: "totals", type: "string", isOptional: true },
        { name: "staff_id", type: "string", isOptional: false },
        { name: "location_id", type: "string", isOptional: false },

        { name: "items_last_fetch_millis", type: "number", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "inventory_movement_items",
      columns: [
        { name: "inventory_movement_id", type: "string" },
        { name: "status", type: "string", isOptional: true },
        { name: "counted", type: "number", isOptional: true },
        { name: "stock_code", type: "string", isOptional: true },
        { name: "product_id", type: "string", isOptional: false },

        { name: "initial_expected", type: "number", isOptional: true },
        { name: "expected", type: "number", isOptional: true },
        { name: "cost", type: "number" },
        { name: "manual", type: "boolean" },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "counts",
      columns: [
        { name: "inventory_movement_id", type: "string" },
        { name: "inventory_movement_item_id", type: "string" },
        { name: "adjust_by", type: "number" },
        ...syncMetaColumns,
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "stock_counts",
      columns: [
        { name: "name", type: "string" },
        { name: "status", type: "string" },
        { name: "location_id", type: "string" },
        { name: "retailer_stocktake_id", type: "string", isOptional: true },
        { name: "items_last_fetch_millis", type: "number", isOptional: true },
        { name: "source", type: "string", isOptional: false },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "stock_count_lines",
      columns: [
        { name: "barcode", type: "string" },
        { name: "product_id", type: "string", isOptional: true },
        { name: "stock_count_id", type: "string", isOptional: false },
        { name: "initial_expected", type: "number", isOptional: true },
        { name: "expected", type: "number", isOptional: true },
        { name: "name", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "stock_count_items",
      columns: [
        { name: "stock_count_line_id", type: "string" },
        { name: "status", type: "string" },
        { name: "counted", type: "number" },
        { name: "counted_at", type: "number" },
        { name: "remote_id", type: "string", isOptional: true },
        ...syncMetaColumns,
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "locations",
      columns: [
        { name: "name", type: "string" },
        { name: "retailer_location_key", type: "string", isOptional: true },
        { name: "enabled", type: "boolean" },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "staffs",
      columns: [
        { name: "full_name", type: "string" },
        { name: "initials", type: "string" },
        { name: "enabled", type: "boolean" },
        { name: "username", type: "string", isOptional: true },
        { name: "user_id", type: "string", isOptional: true },
        { name: "email_address", type: "string", isOptional: true },
        { name: "terminal_ids", type: "string" },
        { name: "has_user_account", type: "boolean" },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "departments",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "description", type: "string" },
        { name: "markup", type: "string", isOptional: true },
        { name: "preferred_tax_group_id", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "categories",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "description", type: "string" },
        { name: "department_id", type: "string", isOptional: false },
        { name: "markup", type: "string", isOptional: true },
        { name: "preferred_tax_group_id", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "suppliers",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "supp_code", type: "string", isOptional: false },
        { name: "active", type: "boolean", isOptional: false },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "terminals",
      columns: [
        { name: "name", type: "string" },
        {
          name: "default_receipt_template_id",
          type: "string",
          isOptional: false,
        },
        { name: "invoice_sequence", type: "number" },
        { name: "sale_sufix", type: "string", isOptional: true },
        { name: "sale_prefix", type: "string", isOptional: true },
        { name: "enabled", type: "boolean" },
        { name: "layout_id", type: "string", isOptional: true },
        { name: "payment_method_ids", type: "string" },
        { name: "print_receipt_on_checkout", type: "boolean" },
        { name: "terminal_open_time", type: "number", isOptional: true },
        { name: "terminal_close_time", type: "number", isOptional: true },
        { name: "open_terminal_closure_id", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "pay_types",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "description", type: "string", isOptional: true },
        { name: "subtext", type: "string", isOptional: true },
        { name: "logo", type: "string", isOptional: true },
        { name: "available", type: "boolean", isOptional: false },
        { name: "online_only", type: "boolean", isOptional: false },
        { name: "internal", type: "boolean", isOptional: false },
        { name: "configuration_url", type: "string", isOptional: true },
        { name: "default_gateway_url", type: "string", isOptional: true },
        { name: "platforms", type: "string", isOptional: false },
        { name: "channels", type: "string", isOptional: false },
        { name: "availablePos", type: "boolean", isOptional: false },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "payment_methods",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "paytype_id", type: "string", isOptional: false },
        { name: "enabled", type: "boolean" },
        { name: "retailer_pay_code", type: "string", isOptional: true },
        { name: "configuration", type: "string", isOptional: true },
        {
          name: "retailer_pay_type_id",
          type: "string",
          isOptional: true,
        },
        { name: "handler", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "receipt_template_type",
      columns: [
        { name: "html", type: "string", isOptional: false },
        { name: "css", type: "string", isOptional: false },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "receipt_template",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "receipt_template_type_id", type: "string", isOptional: false },
        { name: "enabled", type: "boolean" },
        { name: "settings", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "tax_groups",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "short_name", type: "string", isOptional: true },
        { name: "arrive_percentage", type: "number", isOptional: false },
        { name: "sale_percentage", type: "number", isOptional: false },
        ...baseColumns,
      ],
    }),

    tableSchema({
      name: "retailer_pay_types",
      columns: [
        { name: "pay_code", type: "string", isOptional: true },
        { name: "pay_description", type: "string", isOptional: true },
        ...baseColumns,
      ],
    }),

    tableSchema({
      name: "docket_template_types",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "html", type: "string", isOptional: false },
        { name: "css", type: "string", isOptional: false },

        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "docket_templates",
      columns: [
        { name: "name", type: "string", isOptional: false },
        { name: "default_template_type_id", type: "string", isOptional: false },
        { name: "enabled", type: "boolean" },
        { name: "filters", type: "string", isOptional: false },
        { name: "terminal_ids", type: "string", isOptional: false },
        { name: "automatically_print", type: "boolean", isOptional: false },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "product_kits",
      columns: [
        { name: "product_id", type: "string", isOptional: false },
        { name: "kit_id", type: "string", isOptional: false },
        { name: "description", type: "string", isOptional: true },
        { name: "price", type: "number", isOptional: false },
        ...baseColumns,
      ],
    }),
    tableSchema({
      name: "product_kit_items",
      columns: [
        { name: "product_kit_id", type: "string", isOptional: false },
        { name: "product_id", type: "string", isOptional: false },
        { name: "quantity", type: "number", isOptional: false },
        { name: "price", type: "number", isOptional: false },
        ...baseColumns,
      ],
    }),
  ],
});
